import axios from 'axios';

export default {
    /**
     * Загружает информацию о профиле пользователя
     * @param params
     * @param success
     * @param failure
     * @returns {Promise<void>}
     */
    async loadUserProfile(params, success, failure) {
        await axios
            .get('/api/user/profile/', {params})
            .then(res => {
                success(res.data);
            })
            .catch(err => failure(err));
    },

    /**
     * Сохраняет профиль пользователя
     * @param params
     * @param success
     * @param failure
     * @returns {Promise<void>}
     */
    async saveUserProfile(params, success, failure) {
        await axios
            .post('/api/user/profile/', params)
            .then((res) => success(res.data))
            .catch(err => failure(err));
    },

    /**
     * Изменяет пароль пользователя
     * @param params
     * @param success
     * @param failure
     * @returns {Promise<void>}
     */
    async changePassword(params, success, failure) {
        await axios
            .post('/api/user/profile/change-password/', params)
            .then((res) => success(res.data))
            .catch(err => failure(err));
    }
};